module.exports = __webpack_public_path__ + "img/discord.03a0f188.svg";